import { render, staticRenderFns } from "./PublishPanel.vue?vue&type=template&id=1c0b5dc9&scoped=true&"
import script from "./PublishPanel.vue?vue&type=script&lang=js&"
export * from "./PublishPanel.vue?vue&type=script&lang=js&"
import style0 from "./PublishPanel.vue?vue&type=style&index=0&id=1c0b5dc9&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c0b5dc9",
  null
  
)

export default component.exports